import { createRoot } from "react-dom/client";
import { AppProviders } from "src/AppProviders";
import { markLiveUpdateReady } from "src/capacitor/liveUpdate";
import Router from "./Router";

const container = document.getElementById("app");

if (!window.__APP_ROOT__) {
	window.__APP_ROOT__ = createRoot(container);
}
const root = window.__APP_ROOT__;

function render(Component) {
	root.render(
		<AppProviders>
			<Component />
		</AppProviders>,
	);
}

render(Router);
markLiveUpdateReady();

if (import.meta.hot) {
	import.meta.hot.accept((newModule) => {
		const NextRouter = newModule.Router || Router;
		render(NextRouter);
	});
}
